// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1BTce","loaderOuter":"PageOverlayLoader_loaderOuter__2ycJ0"};